import './App.css';
import Content from './components/Content';

const App = () => (
  <div class="background"> 
    <Content /> 
  </div>
);

export default App
